import {assert} from 'assert-ts';
import type {PartValueModifier} from 'schemaDefinition/types';
import {isNullish} from 'schemaDefinition/functions';
import {isExpressionValue} from 'services/utils';
import {isWorkValue} from 'services/utils/functions/isWorkValue';
import {CodeListRef} from 'schemas';

export const languagesModifier: PartValueModifier = ({
  value,
  part,
  entityValue,
}) => {
  assert(
    isNullish(value) || Array.isArray(value),
    'languagesModifier: value must be null or an array',
    {value, part},
  );
  assert(
    isWorkValue(entityValue) || isExpressionValue(entityValue),
    'languagesModifier: entityValue must be Work or Expression',
    {entityValue, part},
  );

  if (!Array.isArray(value)) {
    return {value};
  }

  // Values without mul
  const valuesWithoutMul = ((value ?? []) as string[]).filter(
    v => v !== CodeListRef.LANGUAGE.Multi,
  );

  // Allow mul as the only language
  if (valuesWithoutMul.length === 0 && value.length === 1) {
    return {value};
  }

  if (
    valuesWithoutMul.includes(CodeListRef.LANGUAGE.Bokmål) &&
    valuesWithoutMul.includes(CodeListRef.LANGUAGE.Nynorsk)
  ) {
    if (valuesWithoutMul.length >= 3) {
      return {
        value: [CodeListRef.LANGUAGE.Multi, ...valuesWithoutMul],
      };
    } else {
      return {value: valuesWithoutMul};
    }
  }

  if (valuesWithoutMul.length >= 2) {
    return {
      value: [CodeListRef.LANGUAGE.Multi, ...valuesWithoutMul],
    };
  }

  return {value: valuesWithoutMul};
};
